import React from 'react'
import { Typography, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import TimelineIconText from 'redesign/components/molecules/timeline-icon-text'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { formatDateRange } from 'redesign/shared/date/utils'
import { ZERO, type AbsencePeriodsT } from 'shared/constants'
import { ABSENCE_PERIOD_ICONS, ABSENCE_PERIOD_TRANSLATION, ABSENCE_TYPE_TRANSLATIONS } from '../constants'
import { Container, DatesWrapper } from '../styles'
import type { TimelineAbsenceDatesProps } from '../types'

const SimpleAbsenceDates: React.FC<TimelineAbsenceDatesProps> = ({ dates, dateFrom, dateTo }) => {
  const { palette } = useTheme()
  const { t, locale } = useFavurTranslation()

  if (!dates || dates.length === ZERO) return null

  const firstType = dates[ZERO].type as string
  const firstPeriod = dates[ZERO].period as AbsencePeriodsT

  return (
    <Container>
      <TimelineIconText icon={ABSENCE_PERIOD_ICONS[firstPeriod]} color={palette.text.secondary}>
        <Typography color={palette.text.primary} variant="subtitle2">
          {t(ABSENCE_TYPE_TRANSLATIONS[firstType])}
        </Typography>
      </TimelineIconText>
      <DatesWrapper>
        <Typography variant="body2" color={palette.text.primary}>
          {`${formatDateRange({
            dates: { startDate: dateFrom, endDate: dateTo },
            dateFormat: DATE_FORMAT_VARIANTS.shortWithWeekday,
            t,
            locale,
          })} ${t(ABSENCE_PERIOD_TRANSLATION[firstPeriod])}`}
        </Typography>
      </DatesWrapper>
    </Container>
  )
}

export default SimpleAbsenceDates
